// AI-CONTEXT: See docs/features/impact-per-euro-methodiek.md

/**
 * Presentatie-afronding van het kengetal (methodiek § 5.3): één puntgetal,
 * afgerond op € 0,05 en altijd naar beneden (richting min oneindig).
 *
 * Werkt in hele centen om float-ruis te neutraliseren: 0.1 + 0.2 moet € 0,30
 * blijven, niet naar € 0,25 zakken.
 *
 * @param {number} waarde - Het onafgeronde kengetal
 * @returns {number|null} afgerond op 0,05 naar beneden, of null bij niet-eindige invoer
 */
const rondAfOpVijfCent = (waarde) => {
  if (typeof waarde !== 'number' || !Number.isFinite(waarde)) return null

  const centen = Math.round(waarde * 100)
  return (Math.floor(centen / 5) * 5) / 100
}

export default rondAfOpVijfCent
